import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { getTranslation } from "orion-components/i18n";

const DeleteBookmarkDialog = ({ open, onClose, onSave, isSaving, bookmarkName }) => {
	const handleDialogClose = () => {
		if (!isSaving) {
			onClose();
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleDialogClose}
			PaperProps={{
				style: {
					backgroundColor: "#212327",
					padding: "15px",
					minWidth: "420px"
				}
			}} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-dialog"
		>
			<DialogTitle sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-dialog-title">
				{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.deleteBookmarkDialog.title")}
			</DialogTitle>
			<DialogContent data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-dialog-content">
				<Typography sx={{ color: "#fff", mb: 1.5 }}>
					{getTranslation(
						"global.CBComponents.newVideoPlayer.components.mainMenu.deleteBookmarkDialog.description",
						null,
						bookmarkName || ""
					)}
				</Typography>
			</DialogContent>
			<DialogActions data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-dialog-actions">
				<Button onClick={handleDialogClose} disabled={isSaving} variant="text" style={{ color: "#B2B6BB" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-button">
					{getTranslation(
						"global.CBComponents.newVideoPlayer.components.mainMenu.deleteBookmarkDialog.cancel"
					)}
				</Button>
				<Button onClick={onSave} disabled={isSaving} variant="contained" sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-bookmark-dialog-button-2">
					{getTranslation(
						"global.CBComponents.newVideoPlayer.components.mainMenu.deleteBookmarkDialog.delete"
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

DeleteBookmarkDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	isSaving: PropTypes.bool,
	bookmarkName: PropTypes.string
};

DeleteBookmarkDialog.defaultProps = {
	isSaving: false,
	bookmarkName: ""
};

export default DeleteBookmarkDialog;
